import type { MessageBase } from './BaseBridge';
import { BaseBridge, type BaseBridgeOptions } from './BaseBridge';

export interface WebBridgeOptions extends BaseBridgeOptions {
  origin: string;
  contentWindow: Window;
}

export class WebBridge extends BaseBridge {
  protected options: WebBridgeOptions;
  private messageHandler: any;
  constructor(options: WebBridgeOptions) {
    super(options);
    this.options = {
      ...options,
      origin: new URL(options.origin).origin,
    };
    this.initWebBridge();
  }

  protected postMessage(msg: any) {
    this.options.contentWindow.postMessage(msg, this.options.origin);
  }

  private initWebBridge() {
    const handler = async (event: MessageEvent) => {
      if (event.origin === this.options.origin) {
        const { type } = event.data as MessageBase;
        switch (type) {
          case 'request': {
            const response = await this.handleRequest(event.data);
            this.postMessage(response);
            break;
          }
          case 'response': {
            this.responseHandler(event.data);
            break;
          }
          case 'notification': {
            this.handleNotification(event.data);
            break;
          }
        }
      }
    };
    this.messageHandler = handler;
    window.addEventListener('message', handler);
  }

  request(method: string, params: Record<string, any> | undefined) {
    return this.requestHandler(method, params, this.postMessage.bind(this));
  }
  notify(method: string, payload?: Record<string, any> | undefined) {
    this.postMessage({ type: 'notification', method, payload });
  }
  [Symbol.dispose]() {
    window.removeEventListener('message', this.messageHandler);
  }
}
